<template>
    <div class="cz2__checkout-item__protectors">
        <h2
            id="cz2-protector-heading"
            class="cz2__checkout-item__name"
        >
            {{$t('PREMIUM_PACKAGING')}}
        </h2>

        <div
            role="radiogroup"
            aria-labelledby="cz2-protector-heading"
            class="cz2__checkout-item__protectors__button__wrapper"
        >
            <label
                v-if="availableProtector"
                class="cz2__checkout-item__protectors__button"
            >
                <div
                    :class="{ checked: !selectedProtector.placeholder }"
                    class="cz2__checkout-item__protectors__button--checkbox"
                />

                <div
                    :style="{ backgroundImage: `url(${availableProtector.custom.image})` }"
                    class="cz2__checkout-item__protectors__button--image"
                />

                <div class="cz2__checkout-item__protectors__button--row">
                    <div>
                        {{ addProtectorCopy }}
                    </div>

                    <span class="cz2__checkout-item__protectors__button__price">
                        + {{ formatPriceValue(protectorPrice) }}
                    </span>
                </div>

                <input
                    type="checkbox"
                    name="protector"
                    value="protector"
                    :checked="protectorSelected"
                    @change="toggleProtector"
                    class="cz2__checkout-item__protectors__checkbox"
                >
            </label>

            <label v-if="availablePackaging" class="cz2__checkout-item__protectors__button">
                <div
                    :class="{ checked: discreetPackagingSelected }"
                    class="cz2__checkout-item__protectors__button--checkbox"
                />

                <div
                    class="cz2__checkout-item__protectors__button--image cz2__box-image"
                />
                <div class="cz2__checkout-item__protectors__button--row">
                    <div class="cz2__checkout-item__protectors__button--row-row">
                        {{ $t('DISCREET_PACKAGING') }}

                        <button
                            type="button"
                            @click.stop="showTooltip"
                            :aria-label="$t('DISCREET_TOOLTIP_ARIA')"
                            class="cz2__discreet-tooltip"
                        />
                    </div>

                    <span class="cz2__checkout-item__protectors__button__price">
                        + {{ formatPriceValue(discreetBoxPrice) }}
                    </span>
                </div>

                <input
                    type="checkbox"
                    name="discreetPackaging"
                    value="discreetPackaging"
                    :checked="discreetPackagingSelected"
                    @change="toggleDiscreetPackaging"
                    class="cz2__checkout-item__protectors__checkbox"
                >
            </label>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__checkout-item__protectors {
            border-top: 2px solid rgba(237, 237, 237, 1);
            padding-top: 10px;
            .cz2__checkout-item__name {
                margin-bottom: 4px;
            }

            .cz2__checkout-item__protectors__button__wrapper {
                display: flex;
                flex-direction: column;
                gap: 16px;
            }

            .cz2__checkout-item__protectors__button {
                position: relative;

                margin: 0;
                border-radius: 12px;
                padding-right: 16px;
                padding-left: 8px;

                height: 72px;
                width: 100%;

                display: flex;
                gap: 8px;
                align-items: center;

                background-color: #222222;

                @include font(h3-secondary);
                color: white;

                .cz2__checkout-item__protectors__button--row {
                    display: flex;
                    flex-direction: column;
                    text-transform: none;
                }

                .cz2__checkout-item__protectors__button--row-row {
                    display: flex;
                    gap: 4px;
                }

                .cz2__checkout-item__protectors__button--checkbox {
                    margin-left: 8px;
                    width: 24px;
                    height: 24px;

                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-image: url('../assets/icons/check-default.svg');

                    &.checked {
                        background-image: url('../assets/icons/check-checked.svg');
                    }
                }

                .cz2__checkout-item__protectors__button--image {
                    width: 48px;
                    height: 48px;

                    background-size: cover;
                    background-repeat: no-repeat;
                    background-position: center;
                }

                .cz2__box-image {
                    background-image: url('../assets/images/discreet-box-new.png');
                    background-size: 80%;
                }

                .cz2__checkout-item__protectors__button__price {
                    @include font(h3);
                    white-space: nowrap;
                }

                .cz2__checkout-item__protectors__checkbox {
                    position: absolute;
                    top: 0;
                    left: 0;
                    margin: 0;
                    padding: 0;

                    width: 100%;
                    height: 100%;

                    appearance: none;
                    outline: none;
                    cursor: pointer;
                }

                .cz2__discreet-tooltip {
                    z-index: 1; // Make tooltip clickable over the input
                    width: 24px;
                    height: 24px;
                    background-image: url(../assets/icons/information-icon-white.svg);
                }

                @include respond-above(sm) {
                    .cz2__checkout-item__protectors__button--row {
                        flex: 1;
                        flex-direction: row;
                        justify-content: space-between;
                    }
                }

                @include respond-above(md) {
                    height: 56px;

                    .cz2__checkout-item__boxes__radio {
                        &:checked {
                            &:after {
                                height: 60px;
                            }
                        }
                    }
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__checkout-item__protectors__button__wrapper {
            flex-direction: row;
        }
    }

    #cz2.cz2__is-sb {
        .cz2__checkout-item__protectors {
            .cz2__checkout-item__protectors__button {
                color: #000;
                background-color: #F8EBBB80;
            }
        }
    }

    #cz2.cz2.cz2__is-mariners {
        .cz2__checkout-item__protectors__button {
            .cz2__checkout-item__protectors__button--checkbox {
                &.checked {
                    background-image: url('../assets/images/branded/knicks/check-checked.svg');
                }
            }
        }
    }
</style>

<script>
    import * as constants from '../constants';

    import { formatPrice } from '../helpers/formatPrice';

    export default {
        data() {
            return {
                protectorSelected: false,
                discreetPackagingSelected: false,
            };
        },

        computed: {
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            mainController() {
                return this.$store.state.customizer.mainController;
            },

            cart() {
                return this.$store.getters.cart;
            },

            selectedProtector() {
                return this.mainController.selectedAtPlacement(constants.PLACEMENT_PROTECTOR);
            },

            placeholderProtector() {
                const protector = this.mainController.findPlacement(constants.PLACEMENT_PROTECTOR);

                if (protector == null) {
                    return null;
                }

                return protector.components.find((p) => p.placeholder);
            },

            availableProtector() {
                return this.$store.getters.availableProtector;
            },

            protectorPrice() {
                const component = this.availableProtector;
                let price = 0;

                if (component == null) {
                    return price;
                }

                if (component.price != null) {
                    price = component.price[0].value;
                }

                price = this.viewController.getPrice(this.availableProtector);

                return price;
            },

            selectedPackaging() {
                return this.viewController.selectedAtPlacement(constants.PLACEMENT_DISCREET_PACKAGING);
            },

            placeholderPackaging() {
                const packaging = this.viewController.findPlacement(constants.PLACEMENT_DISCREET_PACKAGING);

                return packaging.components.find((p) => p.placeholder);
            },

            availablePackaging() {
                return this.$store.getters.availablePackaging;
            },

            discreetBoxPrice() {
                const component = this.availablePackaging;
                let price = 0;

                if (component == null) {
                    return price;
                }

                if (component.price != null) {
                    price = component.price[0].value;
                }

                price = this.mainController.getPrice(this.availablePackaging);

                return price;
            },

            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            addProtectorCopy() {
                return this.isKiosk ? this.$t('ADD_A_POP_PROTECTOR') : this.$t('SHIPS_INSIDE_POP_PROTECTOR');
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },
        },

        mounted() {
            this.updateState();

            this.updateTimer = setInterval(this.updateState, 500);
        },

        beforeDestroy() {
            if (this.updateTimer) {
                clearInterval(this.updateTimer);
            }
        },

        methods: {
            updateState() {
                const protector = this.mainController.findPlacement(constants.PLACEMENT_PROTECTOR);

                if (protector) {
                    this.protectorSelected = !this.mainController.selectedAtPlacement(constants.PLACEMENT_PROTECTOR)?.placeholder;
                }

                const packaging = this.mainController.findPlacement(constants.PLACEMENT_DISCREET_PACKAGING);

                if (packaging) {
                    this.discreetPackagingSelected = !this.mainController.selectedAtPlacement(constants.PLACEMENT_DISCREET_PACKAGING)?.placeholder;
                }
            },

            toggleProtector() {
                if (!this.protectorSelected) {
                    this.addProtector();
                } else {
                    this.removeProtector();
                }
            },

            toggleDiscreetPackaging() {
                if (!this.discreetPackagingSelected) {
                    this.addDiscreetPackaging();
                } else {
                    this.removeDiscreetPackaging();
                }
            },

            addProtector() {
                if (this.availableProtector) {
                    this.protectorSelected = true;

                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Add protector',
                    });

                    this.$store.dispatch('bumpVersion');

                    this.mainController.updateComponent(constants.PLACEMENT_PROTECTOR, this.availableProtector.code);
                }
            },

            removeProtector() {
                const protector = this.mainController.findPlacement(constants.PLACEMENT_PROTECTOR);

                if (protector) {
                    this.protectorSelected = false;

                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Remove protector',
                    });

                    this.$store.dispatch('bumpVersion');

                    this.mainController.updateComponent(constants.PLACEMENT_PROTECTOR, this.placeholderProtector.code);
                }
            },

            addDiscreetPackaging() {
                if (this.availablePackaging) {
                    this.discreetPackagingSelected = true;

                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Add packaging',
                    });

                    this.$store.dispatch('bumpVersion');

                    this.mainController.updateComponent(constants.PLACEMENT_DISCREET_PACKAGING, this.availablePackaging.code);
                }
            },

            removeDiscreetPackaging() {
                const packaging = this.mainController.findPlacement(constants.PLACEMENT_DISCREET_PACKAGING);

                if (packaging) {
                    this.discreetPackagingSelected = false;

                    this.$store.dispatch('log', {
                        level: 'info',
                        message: 'Remove packaging',
                    });

                    this.$store.dispatch('bumpVersion');

                    this.mainController.updateComponent(constants.PLACEMENT_DISCREET_PACKAGING, this.placeholderPackaging.code);
                }
            },

            formatPriceValue(price) {
                return formatPrice(this.$store.state, price, 'standard');
            },

            showTooltip() {
                this.$store.dispatch('showDiscreetPackagingModal', true);
            },
        },
    };
</script>
